<template>
  <div class="integrated-entrance">
    <!-- 顶部导航 -->
    <div class="zw-header entrance-header">
      <div class="zw-nav" style="width: 100%;height: 60px;padding-left: 0">
        <div class="zw-nav-left">
          <div style="height: 58px">
            <img src="../assets/img/logo_12.png" height="100%" alt="">
          </div>
        </div>
        <div class="zw-nav-right">
          <div style="display: flex;align-items: center">
            <img src="../assets/img/cdldh01.png" width="26" alt="">
            <span style="padding-right: 15px;color: #ffffff">029-89181990</span>
          </div>
          <el-button size="mini" type="danger" @click="handleGetScheme">获取方案</el-button>
        </div>
      </div>
      <!-- 主内容区域 -->
      <main class="entrance-main">
        <!-- 标题区域 -->
        <div class="title-section">
          <h1 class="main-title">鑫众为智慧综合管理平台</h1>
          <p class="sub-title">XINZHONGWEI INTELLIGENT INTEGRATED MANAGEMENT PLATFORM</p>
        </div>
        <!-- 产品网格 -->
        <div class="product-grid-wrapper">
          <button class="nav-btn nav-btn-left" @click="prevPage">
            <i style="font-size: 26px" class="el-icon-back" />
          </button>
          <div class="product-grid">
            <div
              v-for="(item, index) in currentProducts"
              :key="index"
              class="product-card"
              @click="onViewDetails(item)"
            >
              <div class="card-icon">
                <img :src="pictureBaseUrl + item.topImage" :alt="item.shortName">
              </div>
              <div class="card-title">{{ item.shortName }}</div>
              <div class="card-hover-bar">
                <i style="font-size: 22px" class="el-icon-right" />
              </div>
            </div>
          </div>
          <button class="nav-btn nav-btn-right" @click="nextPage">
            <i style="font-size: 26px" class="el-icon-right" />
          </button>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { getProductWebList } from '@/js/productModule'
import { pictureBaseUrl } from '@/utils/request'

export default {
  name: 'IntegratedEntrance',
  data() {
    return {
      pictureBaseUrl: pictureBaseUrl,
      currentPage: 0,
      pageSize: 12,
      products: []
    }
  },
  computed: {
    currentProducts() {
      const start = this.currentPage * this.pageSize
      return this.products.slice(start, start + this.pageSize)
    },
    totalPages() {
      return Math.ceil(this.products.length / this.pageSize)
    }
  },
  created() {
    this.getProductWebList()
  },
  methods: {
    // 获取方案
    handleGetScheme() {
      // 1. 解析出完整 URL
      const routeData = this.$router.resolve({
        path: '/getScheme'
      })
      // 2. 新页签打开
      window.open(routeData.href, '_blank')
    },
    onViewDetails(item) {
      const href = item.address
      window.open(href, '_blank')
    },
    // 产品列表
    getProductWebList() {
      getProductWebList().then((res) => {
        if (res.status === 200) {
          this.products = res.data
        } else {
          this.products = []
        }
      })
    },
    prevPage() {
      if (this.currentPage > 0) {
        this.currentPage--
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages - 1) {
        this.currentPage++
      }
    }
  }
}
</script>

<style scoped>

</style>
